import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.table-container {
    position: relative;
}
.table-header {
    position: relative;
    clear: both;
    /* overflow: hidden; */
}
.table-header h2 {
    float: left;
    margin-top: 0;
    font-family: 'Nimbus Sans Light', sans-serif;
    font-weight: normal;
}
.table-header div {
    float: right;
    position: absolute;
    right: 15px;
    bottom: 25px;
    color: #111111;
}
.t-header {
    padding-top: 0;
    padding-right: 4px;
    padding-left: 4px;
    padding-bottom: 8px;
    text-align: right;
    font-size: 14px;
    color: #111111;
}
@media (max-width: 720px) {
    .t-header {
        text-align: center;
    }

    .volatility .t-header {
        text-align: right;
    }

    .label-parts {
        display: flex;
        flex-direction: column;
    }

    .weighted-average tbody td:nth-child(2) {
        vertical-align: top;
    }

    .premium-discount .t-header {
        text-align: right;
    }
}
.t-header:first-of-type {
    text-align: left;
}
.t-definition {
    color: #4f4f4f;
}
.category-title {
    text-align: left;
    color: #111111;
    font-size: 12px;
    margin-bottom: calc(calc(24px / 2) / 2);
}
.category-name {
    text-align: left;
    color: #000000;
    font-size: 18px;
    margin-bottom: calc(24px / 2);
}
.label-parts {
    display: flex;
}
.label-part {
    margin-right: 1%;
}
.label-superscript {
    font-size: 14px;
    left: 2px;
}
.geo-country-name {
    text-align: left;
    min-width: 100px;
}
.label-subtitle {
    font-size: 12px;
  font-family: 'Nimbus Sans Light', sans-serif;
  font-weight: normal;
    color: #3b3b3b;
}
table {
    border-collapse: collapse;
    width: 100%;
    font-size: 14px;
}
table.top-border {
    border-top: none;
}
table.spaced-rows {
    border-top: none;
}
caption {
    font-size: 20px;
  font-family: 'Nimbus Sans Bold', sans-serif;
  font-style: normal;
    text-align: left;
}
tr {
    border-bottom: 1px solid #bbbbbb;
}
tr.no-bottom-border {
    border-bottom: 1px solid #ffffff;
}
td {
    padding: 16px 4px;
    text-align: right;
}
th {
  font-family: 'Nimbus Sans', sans-serif;
  font-weight: 400;
  font-style: normal;
    font-size: 14px;
}
td:first-child {
    text-align: left;
}
.table-pre-content {
    width: calc(100% - (2 * 24px));
    margin: 24px;
    height: 250px;
    background: #f8f8f8;
}
tr.row-filled {
    border-bottom: 12px solid #ffffff;
    background-color: #f8f8f8;
}
tr.row-filled > td {
    padding: 16px;
  font-family: 'Nimbus Sans Light', sans-serif;
  font-weight: normal;
    font-size: 14px;
}
.volatility tr.row-filled > td:nth-child(2) {
    padding: 4px;
}
tr.row-filled:hover {
    background-color: #bbbbbb;
    cursor: pointer;
}
tr.row-filled.no-click:hover {
    background-color: #f8f8f8;
    cursor: default;
}
.show-def {
    color: #086ea1;
}
.etf-aatr-tip-content {
    color: #000000;
    max-width: calc(8px * 79);
    width: 100%;
    padding: 8px;
    text-align: left;
    font-size: 16px;
    font-weight: 400;
    -webkit-filter: contrast(21);
            filter: contrast(21);
    line-height: 1.15;
    display: flex;
}
.etf-aatr-tip-title {
    color: #000000;
    font-family: 'Nimbus Sans';
    line-height: 1;
    padding: 8px;
    justify-content: left;
    display: flex;
    font-size: 16px;
    font-weight: 600;
    float: left;
}
.tooltip-img {
    padding-left: 2px;
}
`;

export default styles;